import React from 'react'
import styles from './FirstView.module.css'
import SlideImg from '../../Common/SlideImg/SlideImg'
import Form from '../Form'

export default function FirstView() {
    const logos = [
        {
            img: '/pages/business/hotelslabo/company_logo_1.png',
            styleClass: styles.content1,
            additionalClass: 'content_sp_none',
        },
        {
            img: '/pages/business/hotelslabo/company_logo_3.png',
            styleClass: styles.content3,
            additionalClass: 'content_sp_none',
        },
        {
            img: '/pages/business/hotelslabo/company_logo_4.png',
            styleClass: styles.content4,
            additionalClass: 'content_sp_none',
        },
        {
            img: '/pages/business/hotelslabo/company_logo_6.png',
            styleClass: styles.content6,
        },
        {
            img: '/pages/business/hotelslabo/company_logo_7.png',
            styleClass: styles.content7,
        },
        {
            img: '/pages/business/hotelslabo/company_logo_8.png',
            styleClass: styles.content8,
        },
        {
            img: '/pages/business/hotelslabo/company_logo_9.png',
            styleClass: styles.content9,
        },
        {
            img: '/pages/business/hotelslabo/company_logo_10.png',
            styleClass: styles.content10,
        },
    ]

    return (
        <section id='fast_view' className={styles.fastView}>
            <div className={styles.fastViewBackgroundSp}>
                <header>
                    <img
                        src='/pages/business/hotelslabo/logo_white.png'
                        alt='ホテルズラボのロゴ'
                    />
                </header>
                <div className={styles.fastViewBox}>
                    <div className={styles.fastViewImageSp}>
                        <img
                            src='/pages/business/hotelslabo/first_view_image_sp.png'
                            alt='ホテル人材特化 採用決定までのコスト0円の採用DXプラットフォーム'
                        />
                    </div>
                </div>
            </div>

            <div className={styles.wrap}>
                {Array.from({ length: 3 }).map((_, slideIndex) => (
                    <ul
                        key={`slide-${slideIndex}`}
                        className={styles.slideshow}
                    >
                        {logos.map((logo, index) => (
                            <SlideImg
                                key={`slide-${slideIndex}-${index}`}
                                img={logo.img}
                                styleClass={logo.styleClass}
                            />
                        ))}
                    </ul>
                ))}
            </div>

            <Form />
        </section>
    )
}
